import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Jump To Category`('0.0.1')({
  gutterless: true,
  view: () => (
    <UI.Modules.Page.Reusable
      value={{ path: 'roofing', name: 'Roofing Blog - Jump to Category' }}
    />
  ),
  edit: {},
});
